<template>
  <div class="l-wrapper">
    <Loading />
    <NuxtPage />
  </div>
  <UiPartsModalTextModal />
</template>
<script setup lang="ts">
import { register } from 'swiper/element/bundle'
import { useLocaleHeadConfig } from '~/composables/useSeo'

useLocaleHeadConfig()

// Swiper読み込み
if (import.meta.client) {
  register()
}

onMounted(() => {
  document.documentElement.classList.add('loaded')
})
</script>
<style lang="scss" scoped></style>
